const cardBackgroundColor = ['#2e86ef', '#e0a700', '#70aa0c', '#1b6ce5', '#e96a10', '#8531dd', '#0e9023', '#c42d93'];
const cardClass = ['icon-file', 'icon-image', 'icon-intersect', 'icon-calendar', 'icon-items', 'icon-document', 'icon-cloud', 'icon-label', 'icon-module'];
export default {cardBackgroundColor, cardClass};



// WEBPACK FOOTER //
// ./src/enums/cardStyle.js